import { useSearchParams } from 'react-router-dom';

import PendingApplications from './SectionsForAMApplications/PendingApplications';
import TrashPendingApplications from './SectionsForAMApplications/TrashPendingApplications';
import ActiveAMApplicationsCases from './SectionsForAMApplications/ActiveAMApplicationsCases';

import subpageSelection from '../../styles/SubpageSelection.module.css';

export default function AMApplications({ userId }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const section = searchParams.get('section') || 'pending-applications';

    return (
        <>
            <div className={subpageSelection.panel}>
                <a onClick={() => setSearchParams({ section: 'pending-applications' })} className={`${subpageSelection.buttonToSubPages} ${(section === 'pending-applications' || section === 'trash-pending-applications') ? subpageSelection.active : ''}`}>Заявки, по которым ожидается решение СРО</a>
                <a onClick={() => setSearchParams({ section: 'active-application-cases' })} className={`${subpageSelection.buttonToSubPages} ${section === 'active-application-cases' ? subpageSelection.active : ''}`}>Ваши активные заявки</a>
            </div>
            <div className='pageWrapper'>
                {section == 'pending-applications' ? <PendingApplications userId={userId} />
                : section == 'trash-pending-applications' ? <TrashPendingApplications userId={userId} />
                : section == 'active-application-cases' ? <ActiveAMApplicationsCases userId={userId} />
                : <a className='description'>Выберите вкладку</a>}
            </div>
        </>
    )
}